<template>
  <NavBar />
  <div class="main">
    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>
  </div>
  <!-- <Footer /> -->
</template>

<script lang="ts">
import NavBar from '@/components/NavBar.vue';
import Footer from '@/components/Footer.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'MainLayout',
  components: { NavBar, Footer }
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.main {
  padding-top: $heighNavbar;
  height: 100%;
  position: relative;
  @include calc(min-height, 100%, $heighNavbar);

  @include breakpoint-down(slg) {
    padding-top: $heighNavbarMobile;
    @include calc(min-height, 100%, $heighNavbarMobile);
  }
}
</style>
